import * as React from "react";
import { scroller } from "react-scroll";
import { navigate } from "gatsby";
import { formatNumberDisplay } from "../../../../../utils/format-number";
import { Colors } from "../../../../design-tokens/colors";
import { CovidCaseByCountry_covidCaseOwidByCountry_data } from "../../../../../apollo-types/CovidCaseByCountry";
import DailyCasesChartTiny from "../../../../ui-library/daily-cases-chart/daily-cases-chart-tiny";
import styles from "./country-snapshot-item.styles";

interface SnapshotItemProps {
  value: string | number;
  label: string;
  change?: number | null;
  isPositive?: boolean;
  isPercent?: boolean;
  element?: string;
  countryPageUrl?: string;
  color: string;
  covidData: CovidCaseByCountry_covidCaseOwidByCountry_data[];
  dataKey: string;
}

const SnapshotItem: React.FC<SnapshotItemProps> = ({
  value,
  label,
  change,
  isPositive,
  isPercent,
  element,
  countryPageUrl,
  color,
  covidData,
  dataKey,
}) => {
  const [isHover, setHover] = React.useState<boolean>(false);

  let changeText = change || "";
  if (typeof change === "number") {
    changeText = formatNumberDisplay(change, isPercent);
  }

  const valueText = formatNumberDisplay(value, isPercent);

  const isPositiveChange =
    (change && change > 0 && isPositive) ||
    (change && change < 0 && !isPositive);
  const isNegativeChange =
    (change && change > 0 && !isPositive) ||
    (change && change < 0 && isPositive);

  return (
    <div
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      css={[styles.root, element && { cursor: "pointer" }]}
      onClick={() => {
        if (countryPageUrl) {
          navigate(countryPageUrl);
        }
        if (element) {
          scroller.scrollTo(element, {
            smooth: true,
            duration: 300,
            offset: -40,
          });
        }
      }}
    >
      <div>{label}</div>
      <div css={styles.value}>{!isPercent ? valueText : `${valueText}%`}</div>
      <div
        css={[
          styles.change,
          isPositiveChange && { color: Colors.Green },
          isNegativeChange && { color: Colors.Pink },
        ]}
      >
        {!change ? <span css={styles.flat} /> : null}
        {change && change > 0 ? (
          <span css={styles.upArrow(isPositive ? Colors.Green : Colors.Pink)} />
        ) : null}
        {change && change < 0 ? (
          <span
            css={styles.downArrow(isPositive ? Colors.Pink : Colors.Green)}
          />
        ) : null}
        {!isPercent ? changeText : `${changeText}%`}
      </div>

      {/* @ts-ignore */}
      <DailyCasesChartTiny data={covidData} dataKey={dataKey} color={color} />

      {isHover && (
        <div
          css={[
            styles.hoverUnderline,
            {
              backgroundColor: color,
            },
          ]}
        />
      )}
    </div>
  );
};

export default SnapshotItem;
